import React from "react";
import "./Introduction.css";

const IntroductionBooklet = () => {
  return (
    <div className="outer-wrapper">

      {/* ===== FIRST IMAGE ===== */}
      <div className="section-container">
        <img
          src="/hero/bootcamp.png"
          alt="Bootcamp"
          className="section-img"
        />

        <div className="section-overlay">
          <a href="https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1" target="_blank" rel="noreferrer">
            <button className="section-btn">
              Click Here to Join
            </button>
          </a>

          <p className="or-text">or</p>

          <p className="visit-text">
            Visit:{" "}
            <a
              href="https://forgeyourpeak.in"
              target="_blank"
              rel="noreferrer"
            >
              forgeyourpeak.in
            </a>
          </p>
        </div>
      </div>


      {/* ===== SECOND IMAGE ===== */}
      <div className="section-container">
        <img
          src="/Hero/whyitsworks.png"
          alt="Why It Works"
          className="section-img"
        />
      </div>


      {/* ===== THIRD IMAGE ===== */}
      <div className="section-container">
        <img
          src="/Hero/trythis.jpeg"
          alt="Third Section"
          className="section-img"
        />

        <div className="section-overlays">
          <a href="https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1" target="_blank" rel="noreferrer">
            <button className="section-btn">
              Click Here to Join
            </button>
          </a>
        </div>
      </div>
       {/* ===== FOURTH IMAGE ===== */}
      <div className="section-container">
        <img
          src="/Hero/cricketrs.jpeg"
          alt="Cricketers"
          className="section-img"
        />
      </div>

    </div>
  );
};

export default IntroductionBooklet;

